<template>
  <div>
    <div class="ui form" style="margin-bottom: 30px;">
      <div class="required three fields">
        <div class="field">
          <label for="clinic">Clinic</label>
          <select
            class="ui fluid search dropdown"
            id="clinic-search"
            v-model="selectedClinicId"
            name="clinic"
          >
            <option :value="clinic.id" v-for="clinic in clinics" :key="clinic.id">
              {{ clinic.name }}
            </option>
          </select>
        </div>
        <div class="field">
          <label for="purchasedDate">From Date</label>
          <div style="text-align: center" class="ui calendar" :id="'from-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'From Date'"
                     readonly=""
                     name="formDate">
            </div>
          </div>
        </div>
        <div class="field">
          <label for="purchasedDate">To Date</label>
          <div style="text-align: center" class="ui calendar" :id="'to-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'To Date'"
                     readonly=""
                     name="toDate">
            </div>
          </div>
        </div>
      </div>
      <div class="ui blue right floated submit button"
           style="background-color: #092442"
           @click="getReports()">
        Submit
      </div>
    </div>
    <br>
    <div class="ui divider"></div>
    <br>
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div v-else>
      <div class="centered-header">
        <div class="ui two column center aligned grid"> 
          <div class="column centered-header"> 
            <div class="ui circular green segment centered-header" style="width: 200px; height: 200px;">
              <h2 class="ui header">
                <div class="sub header">
                  Total visits Price
                </div>
                  {{ 
                    formatedPrices.total_price 
                  }}
              </h2>
            </div>
          </div>
          <div class="column centered-header"> 
            <div class="ui circular black segment centered-header" style="width: 200px; height: 200px">
              <h2 class="ui header">
                <div class="sub header">
                  Income transactions
                </div>
                {{ 
                  incomeTransactions
                }}
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div class="ui grid" style="padding-bottom: 50px">
        <div class="ten wide column" style="margin-top: 30px">
          <h4 class="ui dividing header">
            Financial Statment
          </h4>
          <abstractTable
            :data="formatedPrices"
            :definitionTable="true"
            :definitionTableWidth="'20%'"
            :classes="'ui compact definition table'"
          />
          <h4 class="ui dividing header">
            Transactions Stantment
          </h4>
          <abstractTable
            :data="transactionsStatment"
            :definitionTable="true"
            :definitionTableWidth="'20%'"
            :classes="'ui compact definition table'"
          />
        </div>
        <div class="six wide column">
          <echart 
            :chartId="'Report'"
            :hasYAxis="false"
            :chartStyle="'width: 100%; height: 300px'"
            :legend="legend"
            :series="chartSeries()"
            :tooltipData="toolTip"
          />
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  components: {
    echart: require('@/components/abstract_components/ECharts').default,
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default
  },
  data() {
    return {
      from_date: window.moment().startOf('day').toString(),
      to_date: window.moment().endOf('day').toString(),
      selectedClinicId: null,
      visits: [],
      transactions: [],
      loading: true
    }
  },
  mounted () {
    let clinicId = this.selectedClinicId || this.getFromLocalStorage('clinicId') || this.clinics[0].id
    this.selectedClinicId = clinicId
    this.getReports()
  },
  computed: {
    legend () {
      return {
        top: '5%',
        left: 'center'
      }
    },
    toolTip () {
      return {
        trigger: 'item'
      }
    },
    computedPrices () {
      let prices = {
        costPrice: 0,
        discounts: 0,
        doctorProfit: 0,
        netProfit: 0,
        totalPrice: 0
      }
      const visitCosts = this.visits.flatMap(v => v.visit_costs)
      window._.each(visitCosts, cost => {
        prices.totalPrice += Number(cost.total_selling_price)
        prices.netProfit += Number(cost.net_profit)
        prices.doctorProfit += Number(cost.doctor_profit)
        prices.costPrice += Number(cost.total_cost)
        prices.discounts += Number(cost.discount)
      })

      return prices
    },
    formatedPrices () {
      let prices = {}

      prices.cost_Price = this.formatPrice(this.computedPrices.costPrice)
      prices.discounts = this.formatPrice(this.computedPrices.discounts)
      prices.doctor_profit = this.formatPrice(this.computedPrices.doctorProfit)
      prices.net_profit = this.formatPrice(this.computedPrices.netProfit)
      prices.total_price = this.formatPrice(this.computedPrices.totalPrice)
      
      return prices
    },
    transactionsStatment () {
      return {
        income: this.incomeTransactions,
        outcome: this.outcomeTransactions,
        total_money: this.formatPrice((this.income - this.outcome), 2)
      }
    },
    income () {
      return window._.sumBy(this.transactions, transaction => {
        return !transaction.is_purchase && Number(transaction.amount)
      })
    },
    outcome () {
      return window._.sumBy(this.transactions, transaction => {
        return transaction.is_purchase ? Number(transaction.amount) : 0
      })
    },
    outcomeTransactions () {
      return  this.formatPrice(this.outcome, 2)
    },
    incomeTransactions () {
      return this.formatPrice(this.income, 2)
    },
  },
  methods: {
    chartData () {
      let data = []

      let prices = this.computedPrices

      if (prices.netProfit >= 0) {
        data.push({value: prices.netProfit, name: 'Net profit'})
      }

      if (prices.doctorProfit >= 0) {
        data.push({value: prices.doctorProfit, name: 'Doctor profit'})
      }

      if (prices.costPrice >= 0) {
        data.push({value: prices.costPrice, name: 'Total cost'})
      }

      if (prices.discounts >= 0) {
        data.push({value: prices.discounts, name: 'Discount'})
      }

      return data
    },
    chartSeries () {
      return [
        {
          name: 'Financial Statment',
          type: 'pie',
          radius: ['40%', '70%'],
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          label: {
            show: false,
            position: 'center'
          },
          labelLine: {
            show: false
          },
          data: this.chartData()
        }
      ]
    },
    getReports () {
      this.loading = true
      this.$http.get('financial/reports', {
        params: {
          clinic_id: this.selectedClinicId,
          from_date: this.from_date,
          to_date: this.to_date
        }
      }).then(response => {
        this.visits = response.data.visits
        this.transactions = response.data.meta
        this.initGUI()
        this.loading = false
      })
    },
    initGUI() {
      this.$nextTick(() => {
        $('#clinic-search').dropdown()
        $('#clinic-search').dropdown('set selected', this.selectedClinicId)

        $('#from-date').calendar({
          type: 'date',
          onChange: (date) => {
            this.from_date = date
          }
        })

        $(`#from-date`).calendar(
          'set date',
          this.from_date
        )

        $('#to-date').calendar({
          type: 'date',
          onChange: (date) => {
            this.to_date = date
          }
        })
        
        $(`#to-date`).calendar(
          'set date',
          this.to_date
        )
      })
    }
  },
}
</script>

<style scoped>
.centered-header {
  display: flex !important;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/financial_system/ClinicFinancialReport.vue